module.exports = __webpack_public_path__ + "static/social_bg-30a3ff80c144fdddfe9ca163031e0ce9.svg";